import { useInfiniteQuery } from "react-query";
import axios from "axios";
import { AuthContext } from "../../Context/AuthContext";
import { useContext } from "react";

const useFetchRiderPastAssignmentById = () => {
  const { token, user } = useContext(AuthContext);

  const fetchRiderPastAssignment = async ({ pageParam = 1 }) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/packages/rider-assignments/archived/${user.userId}?page=${pageParam}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching rider Past assignment data:",
        error.response
      );
      throw error;
    }
  };

  return useInfiniteQuery(
    ["riderAssignment", user.userId],
    fetchRiderPastAssignment,
    {
      getNextPageParam: (lastPage) => {
        const nextPage = lastPage.currentPage + 1;
        return nextPage <= Math.ceil(lastPage.totalAssignments / 10)
          ? nextPage
          : undefined;
      },
    }
  );
};

export default useFetchRiderPastAssignmentById;
